
<template>
    <flex-element
        :element-type="elementType"
        exclude-classes
        tag="div"
    >
        <a-button
            v-bind="element(1)"
            @element-updated="elementUpdated"
            @click.native="clearFilter"
        >
            CLEAR FILTERS
        </a-button>
    </flex-element>
</template>

<script>
import { mapState } from 'vuex';
import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import listenOnRootMixin from '@/mixins/listen-on-root';

const CUSTOM_ATTR_NAME = 'search-filter-form-id';

export default {
    mixins: [baseOrganism, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Search Reset Button',
        },

        name: {
            type: String,
            default: '',
        },

        activeIndex: {
            type: Number,
            default: -1,
        },

        tag: {
            type: String,
            default: 'div',
        },
    },

    data() {
        return {
            containerClassGroups: ['flexDirection'],
            searchKeywords: [],
            formId: '',
        };
    },

    computed: {
        ...mapState({
            previewMode: state => state.previewMode,
        }),
    },

    mounted() {
        this.formId = this.getElementData(CUSTOM_ATTR_NAME);
    },

    methods: {
        clearFilter() {
            if (this.previewMode) {
                this.clearForm();
                this.updateQueryString();
                this.emitOnRoot('flex::collection::query-refresh');
            }
        },

        updateQueryString() {
            const urlParams = new URLSearchParams(window.location.search);
            const urlParamsUpdated = new URLSearchParams(window.location.search);

            urlParams.forEach((value, key) => {
                if (!key.startsWith('@@')) {
                    urlParamsUpdated.delete(key);
                }
            });

            window.history.replaceState({}, '', `${ window.location.pathname }?${ urlParamsUpdated }`);
        },

        clearForm() {
            const formElement = document.getElementById(this.formId);

            if (formElement) {
                Object.keys(formElement.elements).forEach((i) => {
                    const elem = formElement.elements[i];

                    if (elem.localName === 'input' && elem.type !== 'button') {
                        if (elem.type === 'checkbox' || elem.type === 'radio') {
                            elem.checked = false;
                        } else if (elem.type !== 'submit') {
                            elem.value = '';
                        }
                    } else if (elem.localName === 'select' && elem.options) {
                        Object.keys(elem.selectedOptions).forEach((j) => {
                            elem.selectedOptions[j].selected = false;
                        });
                    }
                });
            }
        },
    },
};
</script>
